import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  static values  = { refreshUrl: String }

  connect() {
    this._interval = setInterval(() => this._refresh(), 60_000)
  }

  disconnect() {
    clearInterval(this._interval)
  }

  _refresh() {
    if (!this.hasContentTarget) return
    if (this.contentTarget.querySelector('.collapse.show')) return

    const url = this.refreshUrlValue
    fetch(url, { headers: { "Accept": "text/html", "X-Requested-With": "XMLHttpRequest" } })
      .then(r => r.ok ? r.text() : null)
      .then(html => {
        if (html) this.contentTarget.innerHTML = html
      })
  }
}
